import { useEffect } from "react";
import { fetchAllCollections } from "@/components/CollectionsPage/api";
import { setCollectionData } from "@/components/CollectionsPage/redux/slice";
import { onBoardUserAPI } from "@/components/PageHome/api";
import { setOnboardingJourneySteps } from "@/components/ProfileSideDrawer/redux/slice";
import { getCookie } from "@/helpers/cookies";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import authTokenSelector from "@/redux/slice/auth/selectors/authToken";
import signedInStatusSelector from "@/redux/slice/auth/selectors/signedInState";
import { handleSegmentInfo, updateUserOnboarded } from "@/redux/slice/auth/slice";

const UserDataManager: React.FC<any> = ({ children }) => {
  const signedInStatus = useAppSelector(signedInStatusSelector);
  const authToken = useAppSelector(authTokenSelector);
  const dispatch = useAppDispatch();

  const UserSavedData = async () => {
    try {
      const collectionsData: any = await fetchAllCollections(authToken);

      if (collectionsData?.savedCollection) {
        dispatch(setCollectionData(collectionsData?.savedCollection));
        dispatch(setOnboardingJourneySteps(collectionsData?.journeyDetails?.Journey));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (signedInStatus === SignedinState.SIGNEDIN) {
      if (authToken) {
        UserSavedData();
      }
    }
  }, [signedInStatus]);

  const UserOnboardingData = async (SegmentInfo) => {
    const response = await onBoardUserAPI(SegmentInfo);

    if (response?.status === 200) {
      dispatch(updateUserOnboarded(true));
      dispatch(handleSegmentInfo(response?.data?.segmentInfo));
    }
  };

  useEffect(() => {
    const segmentInfo = getCookie("segmentInfo");

    if (segmentInfo) {
      const SegmentInfoObject = segmentInfo ? JSON.parse(segmentInfo) : {};

      if (SegmentInfoObject?.type) {
        UserOnboardingData(SegmentInfoObject);
      }
    } else {
      dispatch(updateUserOnboarded(false));
    }
  }, []);

  return <>{children}</>;
};

export default UserDataManager;
